import { render, staticRenderFns } from "./OfferWhatsAppLink.vue?vue&type=template&id=c6ba884c"
import script from "./OfferWhatsAppLink.vue?vue&type=script&lang=js"
export * from "./OfferWhatsAppLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports